import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import {
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	type DialogProps,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { type SyntheticEvent, useEffect, useState } from "react";
import { deleteWorkOrders } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import type { ModalWorkOrder } from "../models/ModalWorkOrder";
import { WorkOrderCard } from "@/shared/work-orders-modals/components/work-order-card";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .input-group-text": {
			display: "none",
		},
	},
	modalTitle: {
		backgroundColor: "#ced2cc",
		color: "#495057",
		textAlign: "center",
	},
	modalWarning: {
		color: "white",
		backgroundColor: "#dc3545",
		textAlign: "center",
	},
	messageTitle: {
		fontSize: 15,
		fontWeight: "bold",
		color: "#0000008A",
	},
}));

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
	data: ModalWorkOrder[] | null;
	suffixTitle?: string;
};

export function DeleteMultipleWorkOrdersModal({
	show,
	onHide,
	data,
	suffixTitle,
}: Props) {
	const classes = useStyles();
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState<string>("");
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [deleteSuccess, setDeleteSuccess] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState<DialogProps["maxWidth"]>("md");

	const [errorAssetPath, setErrorAssetPath] = useState<string>("");

	//functions
	const handleCancel = () => {
		onHide(false);
	};

	const handleClose = (event?: SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setDeleteSuccess(false);
	};

	const handleDeleteBtn = async () => {
		setIsSubmitLoading(true);
		const res = await deleteWorkOrders({
			workOrdersCSV: data?.map((item) => item.WorkOrderId).join(",") || "",
			comments: "",
		});
		if (res.ok) {
			setIsSubmitLoading(false);
			setOpenDeleteDialog(false);
			setTimeout(() => {
				setDeleteSuccess(true);
				onHide(true);
			}, 100);
		} else {
			setIsSubmitLoading(false);
			setError(res.message);
		}
	};

	useEffect(() => {
		if (data != null && show) {
		}
		setIsSubmitLoading(false);
	}, [show]);

	return (
		<>
			{show && (
				<HelmetDexteel
					title={`Delete Multiple Work Orders${suffixTitle ? ` - ${suffixTitle}` : ""}`}
				/>
			)}
			<Dialog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={show}
				onClose={() => handleCancel()}
			>
				<Grid container style={{ padding: "0" }}>
					<Grid item md={12} xs={12}>
						<DialogTitle
							style={{
								padding: "16px 24px 8px 24px",
								marginRight: 0,
								width: "100%",
							}}
						>
							<Grid item md={12} xs={12}>
								<h1 style={{ fontSize: "1.7em", margin: "0" }}>
									DELETE MULTIPLE WORK ORDERS
								</h1>
							</Grid>
						</DialogTitle>
					</Grid>
					<Grid container item>
						<DialogContent dividers>
							<Typography variant="h6" gutterBottom>
								The following work orders will be deleted:
							</Typography>
							{data?.map((workOrder, index) => (
								<WorkOrderCard key={index} workOrder={workOrder} />
							))}
						</DialogContent>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						justifyContent="flex-end"
						style={{ marginTop: "15px" }}
					>
						<DialogActions style={{ padding: "0 10px" }}>
							<Grid
								item
								md={3}
								xs={12}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									fullWidth
									variant="contained"
									color="default"
									onClick={handleCancel}
								>
									Cancel
								</Button>
							</Grid>
							<Grid
								item
								md={3}
								xs={12}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									fullWidth
									startIcon={
										isSubmitLoading && <CircularProgress size="1rem" />
									}
									disabled={isSubmitLoading}
									variant="contained"
									color="secondary"
									onClick={() => setOpenDeleteDialog(true)}
								>
									Delete
								</Button>
							</Grid>
						</DialogActions>
					</Grid>
				</Grid>
			</Dialog>
			<Dialog
				open={openDeleteDialog}
				onClose={() => setOpenDeleteDialog(false)}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogTitle id="responsive-dialog-title">{"WARNING"}</DialogTitle>
				<DialogContent>
					<DialogContentText style={{ padding: 0, margin: 0 }}>
						Be careful, once deleted you will not be able to recover these work
						orders, are you sure you want to delete them?
					</DialogContentText>
				</DialogContent>
				<DialogActions style={{ padding: "16px 24px" }}>
					<Button
						onClick={() => setOpenDeleteDialog(false)}
						autoFocus
						color="default"
					>
						CANCEL
					</Button>
					<Button
						autoFocus
						color="secondary"
						startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
						onClick={handleDeleteBtn}
					>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
			<Snackbar
				open={deleteSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
			>
				<Alert severity="error" onClose={handleClose}>
					Orders deleted
				</Alert>
			</Snackbar>
			<ErrorModal error={error} onHide={() => setError("")} />
			<ErrorModal error={errorAssetPath} onHide={() => setErrorAssetPath("")} />
		</>
	);
}
